/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'sysque-frame',
  templateUrl: './sysque-frame.component.html',
  styleUrls: ['./sysque-frame.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SysQuePopupComponent {
  @Input() componentTitle: string;
}
